import { getStockFiles } from '../../network';
import {
  FETCH_STOCK_FILES,
  SET_STOCK_FILES,
  GET_STOCK_FILES,
  SET_LOADING_STOCK_FILES,
  GET_LOADING_STOCK_FILES
} from './types';

const store = {};

const getDefaultState = () => ({
  stockFiles: [],
  loadingStockFiles: false
});

store.state = getDefaultState();

store.getters = {
  [GET_STOCK_FILES]: (state) => state.stockFiles,
  [GET_LOADING_STOCK_FILES]: (state) => state.loadingStockFiles
};

store.mutations = {
  [SET_STOCK_FILES](state, payload) {
    state.stockFiles = payload;
  },
  [SET_LOADING_STOCK_FILES](state, payload) {
    state.loadingStockFiles = payload;
  }
};

store.actions = {
  async [FETCH_STOCK_FILES]({ commit }, payload) {
    const { companyId, page = 1, size = 10 } = payload;
    try {
      commit(SET_LOADING_STOCK_FILES, true);
      const response = await getStockFiles(companyId, page, size);
      commit(SET_STOCK_FILES, response.data);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      commit(SET_LOADING_STOCK_FILES, false);
    }
  }
};

export default store;
